import axios from "axios";

export const LOGIN_URL = "api/auth/login";
export const REGISTER_URL = "api/auth/register";
export const REQUEST_PASSWORD_URL = "api/auth/forgot-password";

export const ME_URL = "api/me";

/**
 *
 * @param email
 * @param password
 * @return {Promise<AxiosResponse<T>>}
 */
export function login(email, password) {
  return axios.post(LOGIN_URL, { email, password });
}

/**
 *
 * @param email
 * @param fullname
 * @param username
 * @param password
 * @return {Promise<AxiosResponse<T>>}
 */
export function register(email, fullname, username, password) {
  return axios.post(REGISTER_URL, { email, fullname, username, password });
}

/**
 *
 * @param email
 * @return {Promise<AxiosResponse<T>>}
 */
export function requestPassword(email) {
  return axios.post(REQUEST_PASSWORD_URL, { email });
}

/**
 *
 * @return {Promise<AxiosResponse<T>>}
 */
export function getUserByToken() {
  // Authorization head should be fulfilled in interceptor.
  return axios.get(ME_URL);
}
